jQuery(($) => {
    const $swiper = $('.swiper-container');

    if ($swiper.length) {
        require.ensure([], require => {
            require([
                'swiper/dist/js/swiper.jquery.umd'
            ], (Swiper) => {
                // loop over swiper instances and init them
                $swiper.each(function (i, container) {
                    let $container = $(container),
                        centeredSlides = $container.data('centered-slides'),
                        height = $container.data('height') || undefined;

                    new Swiper(container, {
                        loop: true,
                        autoHeight: height === 'auto',
                        height: !isNaN(height) ? height : undefined,
                        centeredSlides: centeredSlides !== true && centeredSlides !== false ? true : centeredSlides,
                        slidesPerView: 'auto',
                        autoplay: $container.data('autoplay') || false,
                        spaceBetween: $container.data('space-between') || 0,

                        nextButton: $container.parent().find('.swiper-button-next'),
                        prevButton: $container.parent().find('.swiper-button-prev'),

                        onSlideChangeEnd() {
                            // force repaint after slide, some browser have render issues otherwise
                            $container.each(function () {
                                this.style.display = 'none';
                                this.offsetHeight;
                                this.style.display = 'block';
                            });
                        }
                    });
                });
            });
        }, 'swiper');
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/lib/layouts/swiper.js